import uuid from "./uuid";

export const toByteArray = function (uniqueId: string) {
    let tempByteArray: number[] = [];
    let byteArray: number[] = [];
    let guid = uniqueId.toLowerCase().replace(/-/g, "");

    for (let i = 0; i < 16; i++) {
        let pair = guid.substring(i * 2, i * 2 + 2);
        tempByteArray.push(parseInt(pair, 16));
    }

    /*
    The byte array order is different from the C# method Guid.ToByteArray
    Read more here: http://msdn.microsoft.com/en-us/library/system.guid.tobytearray.aspx

    Note that the order of bytes in the returned byte array is different from
    the string representation of a Guid value. The order of the beginning four-byte
    group and the next two two-byte groups is reversed, whereas the order of the
    last two-byte group and the closing six-byte group is the same.
        */
    byteArray[0] = tempByteArray[3];
    byteArray[1] = tempByteArray[2];
    byteArray[2] = tempByteArray[1];
    byteArray[3] = tempByteArray[0];

    byteArray[4] = tempByteArray[5];
    byteArray[5] = tempByteArray[4];

    byteArray[6] = tempByteArray[7];
    byteArray[7] = tempByteArray[6];

    for (let i = 8; i < 16; i++) {
        byteArray[i] = tempByteArray[i];
    }

    return byteArray;
};

export const get = function (guid?: string) {
    //Convert the string guid to a byte array
    const thisGuid = guid || uuid();
    const byteArray = toByteArray(thisGuid);
    const charsFromBytes: string[] = new Array(byteArray.length);

    //Take only the first 16 characters and get base64 encoded version
    //Last 2 characters will be "=="
    for (let i = 0; i < 16; i++) {
        charsFromBytes[i] = String.fromCharCode(byteArray[i]);
    }
    const charArray = window.btoa(charsFromBytes.join("")).split("");

    // Mimicking IdSerializer.Get
    for (let i = 0; i < 22; i++) {
        if (charArray[i] === "/") {
            charArray[i] = "_";
        } else if (charArray[i] === "+") {
            charArray[i] = "-";
        }
    }

    return `a${charArray.splice(0, 22).join("")}`;
};

